import React, { useContext, useEffect } from 'react'
import { WizardContext } from '../../generico/CustomStepWizard';
import Popup from "react-popup";
import CuentaCompromisoSocio from '../../generico/CuentaCompromisoSocio';
import authService from '../../../services/login/auth.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import SelectorDeFecha from '../../generico/SelectorDeFecha';
import { trackPromise } from 'react-promise-tracker';
import PrestamoService from '../../../services/pagos/PrestamoService';
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput';

export const TrasladoCuotaPaso1 = (props) => {

    const trasladoCuotaContext = useContext(WizardContext);
    const { state, setState } = trasladoCuotaContext;

    const notifiPopup = (titulo,mensaje) =>
    Popup.register({
        title: titulo,
        content: mensaje,
        buttons: {
            right: [
                {
                    text: "Aceptar",
                    className: "success",
                    action: function () {
                        Popup.close();
                    },
                },
            ],
        },
    });

    useEffect(() => {
        if (state.fechaSeleccionada) {
            calcularMontoInteres();
        }
    }, [state.fechaSeleccionada]);

    const obtenerFechasPermitidas = () => {
        const fechas = [];
        const [dia, mes, anio] = formatearFechaVencimiento(state.credito.fechaVencimiento).split('/');
        const fechaBase = new Date(parseInt(anio), parseInt(mes) - 1, parseInt(dia));
        for (let i = 1; i <= 30; i++) {
            const nuevaFecha = new Date(fechaBase);
            nuevaFecha.setDate(fechaBase.getDate() + i);
            const diferenciaMeses = nuevaFecha.getMonth() - fechaBase.getMonth() +
            (nuevaFecha.getFullYear() - fechaBase.getFullYear()) * 12;
            if (diferenciaMeses > 1) break;
            fechas.push(nuevaFecha);
        }
        return fechas;
    };

    const formatearFechaVencimiento = (fecha) => {
        const fechaVencimiento = fecha.split(' ')[0].replace(/-/g,'/');
        return fechaVencimiento;
    };

    const disableContinuar = () => {
        // return (state.ctaFullData === null || state.infoPagare === null);
    }

    const ctaOrigenValue = (ctaFullData, item) => {
        const usuario = authService.getCurrentUser();
        ctaFullData = { ...ctaFullData, denominacion: usuario.nombreCompleto };
        setState({ ...state, ctaFullData, ctaOrigenSele: item });
    };

    const fechaSeleccionada = async (_fechaSeleccionada) =>{
        if( !_fechaSeleccionada || !state.credito?.fechaVencimiento){
            setState({...state,fechaSeleccionada:_fechaSeleccionada,diferenciaDias:null});
            return;
        }
        const _diferenciaDias = calcularDiferenciaDias(state.credito.fechaVencimiento,_fechaSeleccionada);
        await setState({...state,fechaSeleccionada:_fechaSeleccionada,diferenciaDias : _diferenciaDias});
    }

    const montoValue = (_monto) => {
        setState({ ...state, monto: _monto });
    };

    const checkContinuar = () => {
        // const saldo = parseInt(state.ctaFullData.disponible);
        // let montoAPagar = state.infoPagare.montoAPagar;
        // if (montoAPagar > saldo) {
        //     Popup.queue(notifiPopup("Info", "El monto a pagar es mayor a su saldo actual."));
        //     return false;
        // }
        props.nextStep();
    }

    const calcularDiferenciaDias = (fechaActual,fechaSeleccionada) => {
        if (!fechaActual || !fechaSeleccionada) return 0;

        const [diaVto, mesVto,anioVto ] = fechaActual.split('/');
        const fechaVto = new Date(parseInt(anioVto), parseInt(mesVto) - 1, parseInt(diaVto));

        const [diaSel, mesSel, anioSel] = fechaSeleccionada.split('/');
        const fechaSel = new Date(parseInt(anioSel), parseInt(mesSel) - 1, parseInt(diaSel));

        const diferenciaMs = fechaSel - fechaVto;
        const diferenciaDias = Math.round(diferenciaMs / (1000 * 60 * 60 * 24));

        return diferenciaDias > 0 ? diferenciaDias : 0;
    };

    const calcularMontoInteres = () =>{
        const data = {
            idCredito : state.credito.cuenta,
            fechaEspera: state.fechaSeleccionada
        }
        trackPromise(
            PrestamoService.calcularMontoInteres(data)
            .then( (resp)=>{
                const { codigoRespuesta , mensajeServidor, montoInteres } = resp.data;
                if( codigoRespuesta === '0' ){
                    setState({...state,interesAPagar:montoInteres});
                }else{
                    const message = mensajeServidor ?? 'No se ha podido calcular el interés a pagar. Por favor intente nuevamente.';
                    notifiPopup('Info',message);
                }
            })
        )
    }

    return (
        state.credito === null ?
        <div className="text-center">
            No existen datos
        </div>
        :
        <>
            {/* CUOTA NUMERO */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10">
                            <label className="input-label-bold">Nro. Cuota</label>
                            <input
                                type="text"
                                className="form-control"
                                value={state.credito.cuotasPagadas + 1}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* FECHA DE VENCIMIENTO ACTUAL */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10">
                            <label className="input-label-bold">Fecha de Vencimiento Actual:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formatearFechaVencimiento(state.credito.fechaVencimiento)}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* FECHA DE VENCIMIENTO  */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10" style={{justifyContent:'center',alignItems:'center'}}>
                            <label className="input-label-bold">Seleccionar nueva fecha de vencimiento:</label><br />
                            <SelectorDeFecha
                                fechaSeleccionada={state.fechaSeleccionada}
                                setFechaSeleccionada={fechaSeleccionada}
                                fechasPermitidas={obtenerFechasPermitidas()}
                                value={state.fechaSeleccionada}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* DIFERENCIA DE DÍAS */}
            {state.fechaSeleccionada && (
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-7 col-md-10">
                                <label className="input-label-bold">
                                    Diferencia en Días: 
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={state.diferenciaDias}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ELEGIR CUENTA */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10">
                            <CuentaCompromisoSocio
                                renderMonto="false"
                                selectorValue={ctaOrigenValue}
                                montoValue={montoValue}
                                operacion="DEBITO"
                                tipoCuenta="AHORRO_VISTA"
                                items={state.cuentasOrigen}
                                itemSelected={state.ctaOrigenSele}
                                titleImporte="Ingrese el Importe a Pagar"
                            />
                            
                        </div>
                    </div>
                </div>
            </div>

            {/* INTERES A PAGAR */}
            {state.interesAPagar && (
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-7 col-md-10">
                                <label className="input-label-bold">
                                    Interés a pagar:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formatoSeparadorMilesValue(state.interesAPagar)}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* FOOTER */}
            <div className="row">
                <div className="col-lg-10 col-md-8">
                        <label
                            className="input-label-bold-obligatorio">
                            (*) Campos Obligatorios
                            <br />
                        </label>
                
                </div>
                <div className="col-lg-2 col-md-4">
                        <button
                            disabled={disableContinuar()}
                            className="btn btn-cu-primary"
                            onClick={checkContinuar}
                        >
                            Continuar <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                </div>
            </div>
        </>
    )
}
